import Http from "util/https";
import { API_URL } from "config";
import { downloadFromUrl } from "features/stock/utils/common";

/**
 * 週次補充CSVのフォーマットをダウンロードするAPI
 * @returns void
 */
export default async function downloadLargeCsvApi(): Promise<void> {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/weekly/csv/operation?operation=0`;
  const res = await http.get<{url: string}>(url, {});
  console.log(res);

  downloadFromUrl(res.data.url, '週次補充フォーマット');
}
